import { render, staticRenderFns } from "./HospitalDoctorList.vue?vue&type=template&id=310c8c8b&"
import script from "./HospitalDoctorList.vue?vue&type=script&lang=js&"
export * from "./HospitalDoctorList.vue?vue&type=script&lang=js&"
import style0 from "./HospitalDoctorList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports